
  export default {
    name: `Nuxt3Modal`,
    props: {},
    data() {
      return { show: true }
    },
    mounted() {},
    methods: {
      hide(value) {
        this.$store.commit("setShowNuxt3Modal", false)
        this.$api.auth.setNuxt("DONTSHOW")
      },
      setNuxt2() {
        this.$store.commit("setShowNuxt3Modal", false)
        this.$api.auth.setNuxt("NUXT2")
      },
      async setNuxt3() {
        this.$store.commit("setShowNuxt3Modal", false)
        await this.$api.auth.setNuxt("NUXT3")
        if (process.client && typeof window !== `undefined`) {
          window.location.assign(`/v3/client`)
        }
      }
    }
  }
